<template>
    <div class="custom-modal">
        <b-modal
            v-model="show"
            :title="title"
            @hide="callOnHide"
            :size="size"
        >
            <b-container fluid>
                <div class="body-message">
                <slot name="body-message">
                    <p> {{ message }} </p>
                </slot>
                </div>
                <div class="body-template">
                    <slot name="body-template">
                        <!--template-->
                    </slot>
                </div>
            </b-container>

            <template #modal-footer>
                <b-row class="button-group">
                    <b-col>
                        <b-button
                            class="nd-button-color"
                            v-if="isShowBtn1"
                            variant="light"
                            size="sm"
                            @click="action1"
                        >
                            {{ btn1Txt }}
                        </b-button>
                    </b-col>
                    <b-col>
                        <b-button
                            v-if="isShowBtn2"
                            :variant="btn2style ? btn2style : 'outline-secondary'"
                            class="nd-button-color"
                            size="sm"
                            @click="action2"
                        >
                            {{ btn2Txt }}
                        </b-button>
                        <b-button
                            v-if="isShowBtn3"
                            variant="primary"
                            size="sm"
                            @click="action3"
                            :disabled="disableBtn3"
                        >
                            {{ btn3Txt }}
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {BModal, BContainer, BCol, BButton, BRow} from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css"

export default {
    name: "CustomModal",
    components: {BContainer, BCol, BButton, BModal, BRow},
    data() {
        return {
            show: false,
        }
    },
    props: {
        btn2style: String,
        size: {
            type: String, // value: sm/md/xl
            default: ""
        },
        title: {
            type: String,
            default: "Modal Title"
        },
        message: {
            type: String,
            default: "Modal message"
        },
        isShowBtn1: {
            type: Boolean,
            default: true
        },
        isShowBtn2: {
            type: Boolean,
            default: true
        },
        isShowBtn3: {
            type: Boolean,
            default: true
        },
        callOnHide: {
            type: Function,
            default: () => {}
        },
        isShowPopup: {
            type: Boolean,
            default: false
        },
        btn1Txt: {
            type: String,
            default: "btn1Txt"
        },
        btn2Txt: {
            type: String,
            default: "btn2Txt"
        },
        btn3Txt: {
            type: String,
            default: "btn3Txt"
        },
        disableBtn1: {
            type: Boolean,
            default: false
        },
        disableBtn2: {
            type: Boolean,
            default: false
        },
        disableBtn3: {
            type: Boolean,
            default: false
        },
        callAction1: {
            type: Function,
            default: () => {
                console.log("Action1")
            }
        },
        callAction2: {
            type: Function,
            default: () => {
                console.log("Action2")
            }
        },
        callAction3: {
            type: Function,
            default: () => {
                console.log("Action3")
            }
        }
    },
    watch: {
        isShowPopup(newVal, oldVal) {
            this.show = newVal;
        }
    },
    methods: {
        action1() {
            this.show = false;
            this.callAction1();
        },
        action2() {
            this.show = false;
            this.callAction2();
        },
        action3() {
            this.show = false;
            this.callAction3();
        }
    }
}
</script>
<style lang="scss" scoped>

/deep/ .modal-dialog {
    /*/default width is 500px/*/
}

/deep/ .modal-content {
    border-radius: 0;
}

/deep/ .modal-header {
    height: 48px;
    padding: 0;
}

/deep/ .modal-header .close {
    position: absolute;
    right: 12px;
    font-size: 16px;
    padding: 4px;
    text-align: center;
    margin: 10px 0;
    color: #7e8793;
}

/deep/ .modal-title {
    width: 100%;
    text-align: center;
    height: 26px;
    font-family: 'Noto Sans Korean',serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.63;
    padding: 11px;
    color: var(--darkgray-1);
}
.body-message {
    font-size: 14px;
}
.button-group {
    width: 100%;
    display: flex
}
.button-group > div:first-child {
    text-align: left;
    margin-left: 3px;
    width: 50%;
}

.button-group > div:nth-child(2) {
    width: 50%;
    display: flex;
    justify-content: flex-end;
}

.button-group > div:nth-child(2) button {
    margin: 0 8px
}

.button-group button {
    border-radius: 4px !important;
    width: 61px;
    height: 32px;
}
/deep/ input[type=checkbox] {
    -webkit-appearance:checkbox;
}

/deep/ .btn-primary.disabled, .btn-primary:disabled {
    color: #fff!important;
    background-color: #71b6ffc2 !important;
    border-color: #71b6ffc2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modals/CustomModal.vue